import { render, staticRenderFns } from "./RestaurantIcon.vue?vue&type=template&id=2e1597fe&"
import script from "./RestaurantIcon.vue?vue&type=script&lang=js&"
export * from "./RestaurantIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports